const structuredData = {
  homepage: {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Chicago',
      postalCode: '60610',
      streetAddress: '222 W Merchandise Mart Plaza, Suite 900',
      addressRegion: 'IL'
    },
    url: 'https://www.avant.com/',
    logo: 'https://d33v4339jhl8k0.cloudfront.net/docs/assets/55c8f093e4b089486cada2c7/images/56008ea0c697912820e3cafd/faq-logo.png',
    name: 'Avant',
    sameAs: [
      'https://www.facebook.com/avantusa/',
      'https://twitter.com/avant_us',
      'https://www.linkedin.com/company/avant-us/'
    ],
    description:
      'Avant offers fast and easy online lending services including loans from $2,000-$35,000, and credit cards.',
    email: 'support@avant.com',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '800-712-5407',
      contactType: 'Customer service'
    }
  },
  creditCard: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Avant Credit Card',
    image:
      'https://images.ctfassets.net/vrxttq978is8/7d2TrRGtF13f3Ufx5XA544/02f5d0d8e90ce911bc6c3b16cedb5e4e/avant-cc-lg-2x.png',
    description:
      'The Avant Card helps pay for what you need and may help with building your credit. Start today and we can help improve your credit score over time with on time payments. Fast and easy application process. Zero deposit required.',
    brand: 'Avant',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.5',
      bestRating: '5',
      worstRating: '1',
      ratingCount: '150'
    }
  },
  personalLoans: {
    '@context': 'https://schema.org',
    '@type': 'FinancialProduct',
    name: 'Personal Loan',
    description:
      'Fixed rate personal loans between $2k-$35k. APR ranges from 9.95% to 35.99%. No Prepayment fees.',
    amount: {
      '@type': 'MonetaryAmount',
      currency: 'USD',
      minValue: '2000',
      maxValue: '35000'
    },
    offers: {
      '@type': 'Offer',
      offeredBy: 'https://www.avant.com/personal-loans/'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.5',
      bestRating: '5',
      worstRating: '1',
      ratingCount: '150'
    }
  }
}

export default structuredData
